module.exports = __webpack_public_path__ + "assets/music/epic/Incoming Siege by Jens Kiilstofte.ogg";